function videoPreview() {
    document.querySelectorAll('.iframe-poster').forEach(poster=>{
        poster.addEventListener('click',function(e) {
            const handleClick = new Event('click');
            poster.closest('.iframe-container').querySelector('.iframe-poster').style.display = 'none';
            poster.closest('.iframe-container').querySelector('iframe').style.display = 'block';
            poster.closest('.iframe-container').querySelector('iframe').src +="&autoplay=1";
        })
    });
}
module.exports = videoPreview;